import $ from 'jquery';
(function ($, document, window, undefined) {
  'use strict';

  let pluginName = 'ebdragndrop';
  let $element;

  let defaults = {
    color: '#d0a658;',
    inputName: 'ratings[]',
    disabled: false,
  };

  class Plugin {
    constructor(element, options) {
      this.element = element;

      this.settings = $.extend({}, defaults, options);

      this.$el = $(element);
      this.$el.data(element.name, this);

      this._defaults = defaults;
      this._name = pluginName;

      let meta = this.$el.data(name + '-opts');
      this.opts = $.extend(this._defaults, options, meta);

      this.elementContainer = $(element);
      this.styleCode = 'boxQuestionsPodium';
      this.containerCode = 'boxQuestionsPodium';

      this.setValueDragDrop = options.onUpdate;

      this.clicked = [];
      this.clicked[this.containerCode] = false;

      this.oldStyleAnswers = '';

      this.init();
    }

    init() {
      $element = $(this.element);
      this.count = 0;
      this.setEventHandler();
      this.renderComponent();
    }

    getOSInformation() {
      const userAgent = navigator.userAgent || window.opera;

      if (/android/i.test(userAgent)) {
        const versionMatch = userAgent.match(/Android\s([0-9.]*)/);
        return {
          os: 'Android',
          version: versionMatch ? versionMatch[1] : 'unknown',
        };
      }

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        const versionMatch = userAgent.match(/OS\s([0-9_]*)/);
        return {
          os: 'iOS',
          version: versionMatch
            ? versionMatch[1].replace(/_/g, '.')
            : 'unknown',
        };
      }

      return {
        os: 'Other',
        version: 'Other',
      };
    }

    renderComponent() {
      const osInfo = this.getOSInformation();
      const numberBoxes = this.settings.question.boxTitles.length;
      const boxProperties = [];
      const defaultColor = '#C4C4C4';
      for (let index = 0; index < numberBoxes; index++) {
        const element = {
          title: `${this.settings.question.boxTitles[index].text}`,
          value: this.settings.question.boxTitles[index].value,
          color: defaultColor,
        };
        boxProperties.push(element);
      }
      let container =
        `<div data-questionid="${this.settings.question.questionName}" class='` +
        this.containerCode +
        "'>";
      let questionOptionDiv;
      let questionCount = this.settings.question.choices.length;

      if (
        (osInfo.os === 'iOS' && Number(osInfo.version) <= 17.0) ||
        (osInfo.os === 'Android' && Number(osInfo.version) <= 13.0)
      ) {
        for (let i = 0; i < questionCount; i += 1) {
          questionOptionDiv =
            "<div data-valuenumber='" +
            this.settings.question.choices[i].value +
            "' id='spnBoxPodiumId" +
            [i] +
            "' class='spnMobileBoxQuestions' draggable='true' style='background-color:#666; color:white; width: 100%'>" +
            this.settings.question.choices[i]?.text +
            '</div>';
          container += questionOptionDiv;
        }

        container += '</div>';
        container +=
          '<div style="display:none" class="validationText"><p>Every box must have at least 1 value</p></div>';

        container += `<div class="podiumWrapper" style="flex-wrap: wrap; gap:17px">`;
        for (let i = 0; i < numberBoxes; i += 1) {
          container += `

           <div style="display: flex; flex-direction: column; width: 47%">
               <div style="border: 8px solid ${boxProperties[i].color}; color: ${boxProperties[i].color};"
                   class="podiumNumber">
                     <div>${boxProperties[i].title}</div>
               </div>
               <div data-questionid="${this.settings.question.questionName}" data-boxvalue="${boxProperties[i].value}" style="background-color: ${boxProperties[i].color};" class="boxAnswersColumnPodium"></div>
           </div>

           `;
        }
        container += '</div>';
      } else {
        for (let i = 0; i < questionCount; i += 1) {
          questionOptionDiv =
            "<div data-valuenumber='" +
            this.settings.question.choices[i].value +
            "' id='spnBoxPodiumId" +
            [i] +
            "' class='spnBoxQuestions' draggable='true' style='background-color:#666; color:white'>" +
            this.settings.question.choices[i]?.text +
            '</div>';
          container += questionOptionDiv;
        }

        container += '</div>';
        container +=
          '<div style="display:none" class="validationText"><p>Every box must have at least 1 value</p></div>';

        container += `<div class="podiumWrapper">`;
        for (let i = 0; i < numberBoxes; i += 1) {
          container += `

           <div style="display: flex; flex-direction: column; width: 47%">
               <div style="border: 8px solid ${boxProperties[i].color}; color: ${boxProperties[i].color};"
                   class="podiumNumber">
                     <div>${boxProperties[i].title}</div>
               </div>
               <div data-questionid="${this.settings.question.questionName}" data-boxvalue="${boxProperties[i].value}" style="background-color: ${boxProperties[i].color};" class="boxAnswersColumnPodium"></div>
           </div>

           `;
        }
        container += '</div>';
      }

      $element.append(container);
      if (this.settings.initialRating) {
        this.initialRating(this.settings.initialRating);
      }
    }

    setQuestionValue(self, target) {
      if (!target) return;
      const esclamationMarkElement = '<div class="exclamationMark">!</div>';
      const isRequired = self.settings.question.isRequired;
      const boxQuestionsOptions = $(target)
        .closest('#boxQuestions')
        .find('.boxAnswersColumnPodium');

      const valuesAnswer = [];
      let isRequiredAndHasEmptyBox = false;
      let currentBoxIndex = 0;
      let valuePerBox = [];
      $(boxQuestionsOptions).each((boxIndex, boxObject) => {
        const currentBox = $(boxObject);
        const currentBoxTitle = $(currentBox)
          .parents('#boxQuestions')
          .children('.podiumWrapper')
          .first()
          .children()
          .eq(currentBoxIndex);
        $(currentBoxTitle).children().remove('.exclamationMark');
        const currentBoxValue = $(currentBox).data('boxvalue');
        const currentSelectedBoxValue = {
          boxValue: currentBoxValue,
          answerValue: [],
        };
        if ($(currentBox).children().length === 0 && isRequired) {
          isRequiredAndHasEmptyBox = true;
          $(currentBoxTitle).append(esclamationMarkElement);
        }
        $(currentBox)
          .children()
          .each((optionIndex, obj) => {
            const value = Number(obj.dataset.valuenumber);
            valuesAnswer.push(value);
            currentSelectedBoxValue.answerValue.push(value);
          });
        currentBoxIndex += 1;
        valuePerBox.push(currentSelectedBoxValue);
      });

      let newValue = { value: valuesAnswer, valuePerBox: valuePerBox };

      if (isRequiredAndHasEmptyBox) {
        console.log('ENTROU NO IS REQUIRED TRUE', isRequiredAndHasEmptyBox);
        self.settings.question.setDefaultValueWithOthers();
      } else {
        console.log('ENTROU NO IS REQUIRED FALSE', newValue);
        self.setValueDragDrop(newValue, true);
      }
    }

    setEventHandler() {
      let self = this;
      let activeElement = null;
      const setCurrentAnswerValue = function (target) {
        self.setQuestionValue(self, target);
      };

      self.elementContainer.on(
        {
          dragstart: function (ev) {
            $.event.addProp('dataTransfer');
            ev.originalEvent.dataTransfer.setData(
              'questionId',
              self.settings.question.questionName,
            );
            $(ev.target).addClass('dragging');
            ev.dataTransfer.setData('text', ev.target.id);
          },

          touchstart: function (ev) {
            if (
              $(ev.currentTarget.parentNode).attr('class') ===
              'boxAnswersColumnPodium'
            ) {
              ev.currentTarget.parentNode.style.position = 'static';
            }

            var targetClassList = Array.from(ev.currentTarget.classList);
            if (targetClassList.includes('in-box')) {
              $(ev.currentTarget).removeClass('in-box');
            }

            activeElement = ev;
            $(ev.target).addClass('dragging');
            ev.preventDefault();
          },

          touchend: function (ev) {
            $(ev.target).removeClass('dragging');
          },

          dragend: function (ev) {
            $(ev.target).removeClass('dragging');
          },
        },
        '.spnBoxQuestions',
      );

      self.elementContainer.on(
        {
          dragstart: function (ev) {
            $.event.addProp('dataTransfer');
            ev.originalEvent.dataTransfer.setData(
              'questionId',
              self.settings.question.questionName,
            );
            $(ev.target).addClass('mobileDragging');
            ev.dataTransfer.setData('text', ev.target.id);
          },

          touchstart: function (ev) {
            if (
              $(ev.currentTarget.parentNode).attr('class') ===
              'boxAnswersColumnPodium'
            ) {
              ev.currentTarget.parentNode.style.position = 'static';
            }

            var targetClassList = Array.from(ev.currentTarget.classList);
            if (targetClassList.includes('in-box')) {
              $(ev.currentTarget).removeClass('in-box');
            }

            activeElement = ev;
            $(ev.target).addClass('mobileDragging');
            ev.preventDefault();
          },

          touchend: function (ev) {
            $(ev.target).removeClass('mobileDragging');
          },

          dragend: function (ev) {
            $(ev.target).removeClass('mobileDragging');
          },
        },
        '.spnMobileBoxQuestions',
      );

      function isTargetFromSameQuestion(event) {
        const targetQuestionId =
          $(event.target).data('questionid') ??
          $(event.target).parent().data('questionid');
        const originQuestionId =
          event.originalEvent.dataTransfer.getData('questionId');
        return targetQuestionId == originQuestionId;
      }

      self.elementContainer.on(
        {
          drop: function (event) {
            $.event.addProp('dataTransfer');
            if (!isTargetFromSameQuestion(event)) return;
            var targetClass = $(event.target).attr('class');
            var dragObjId = event.dataTransfer.getData('text');

            var targetParentClass = $(event.target).parent().attr('class');

            if (targetClass === 'boxAnswersColumnPodium') {
              event.preventDefault();
              const draggedObject = $(event.target)
                .parents('#boxQuestions')
                .find(`#${dragObjId}`)[0];
              event.target.appendChild(draggedObject);
              if (event.target) {
                setCurrentAnswerValue(event.target);
              }
            } else if (
              targetClass == 'spnBoxQuestions' &&
              targetParentClass == 'boxAnswersColumnPodium'
            ) {
              event.preventDefault();
              const draggedObject = $(event.target)
                .parents('#boxQuestions')
                .find(`#${dragObjId}`)[0];

              event.target.parentNode.appendChild(draggedObject);
              if (event.target.parentNode) {
                setCurrentAnswerValue(event.target.parentNode);
              }
            }
          },

          touchmove: function (ev) {
            if (activeElement.target) {
              const touch = ev.touches[0];
              activeElement.target.style.position = 'absolute';
              activeElement.target.style.left = `${
                touch.pageX - activeElement.target.offsetWidth / 2
              }px`;
              activeElement.target.style.top = `${
                touch.pageY - activeElement.target.offsetHeight / 2
              }px`;
            }
          },

          touchend: function (event) {
            if (activeElement.target) {
              if (
                $(activeElement.currentTarget.parentNode).attr('class') ===
                'boxAnswersColumnPodium'
              ) {
                activeElement.currentTarget.parentNode.style.position =
                  'relative';
              }

              var myLocation = event.originalEvent.changedTouches[0];
              var realTarget = document.elementFromPoint(
                myLocation.clientX,
                myLocation.clientY,
              );

              var targetClass = $(realTarget).attr('class');
              var dragObjId = activeElement.target.id;

              if (
                targetClass == 'boxQuestionsPodium' ||
                targetClass == 'boxAnswersColumnPodium'
              ) {
                event.preventDefault();

                const draggedObject = $(realTarget)
                  .parents('#boxQuestions')
                  .find(`#${dragObjId}`)[0];

                if (targetClass == 'boxAnswersColumnPodium') {
                  $(draggedObject).addClass('in-box');
                }

                realTarget.appendChild(draggedObject);
                if (realTarget) {
                  setCurrentAnswerValue(realTarget);
                }
              } else if (
                targetClass == 'spnBoxQuestions' ||
                targetClass == 'spnBoxQuestions in-box' ||
                targetClass == 'spnMobileBoxQuestions' ||
                targetClass == 'spnMobileBoxQuestions in-box'
              ) {
                event.preventDefault();

                const draggedObject = $(realTarget)
                  .parents('#boxQuestions')
                  .find(`#${dragObjId}`)[0];

                if (
                  $(realTarget.parentNode).attr('class') !==
                  'boxQuestionsPodium'
                ) {
                  $(draggedObject).addClass('in-box');
                }

                realTarget.parentNode.appendChild(draggedObject);
                if (realTarget.parentNode) {
                  setCurrentAnswerValue(realTarget.parentNode);
                }
              }

              activeElement.target.style.opacity = 1;
              activeElement.target.style.position = 'static';
              activeElement.target = null;
            }
          },

          dragover: function (event) {
            event.preventDefault();
          },
        },
        '.boxAnswersColumnPodium',
      );

      self.elementContainer.on(
        {
          drop: function (event) {
            $.event.addProp('dataTransfer');
            if (!isTargetFromSameQuestion(event)) return;

            var targetClass = $(event.target).attr('class');
            var targetParentClass = $(event.target).parent().attr('class');

            var dragObjId = event.dataTransfer.getData('text');

            if (targetClass == 'boxQuestionsPodium') {
              event.preventDefault();

              const draggedObject = $(event.target)
                .parents('#boxQuestions')
                .find(`#${dragObjId}`)[0];
              event.target.appendChild(draggedObject);
              if (event.target) {
                setCurrentAnswerValue(event.target);
              }
            } else if (
              targetClass == 'spnBoxQuestions' &&
              targetParentClass == 'boxQuestionsPodium'
            ) {
              event.preventDefault();

              const draggedObject = $(event.target)
                .parents('#boxQuestions')
                .find(`#${dragObjId}`)[0];

              event.target.parentNode.appendChild(draggedObject);
              if (event.target) {
                setCurrentAnswerValue(event.target);
              }
            }
          },

          touchmove: function (ev) {
            if (activeElement.target) {
              const touch = ev.touches[0];
              activeElement.target.style.position = 'absolute';
              activeElement.target.style.left = `${
                touch.pageX - activeElement.target.offsetWidth / 2
              }px`;
              activeElement.target.style.top = `${
                touch.pageY - activeElement.target.offsetHeight / 2
              }px`;
            }
          },

          touchend: function (event) {
            if (activeElement.target) {
              var myLocation = event.originalEvent.changedTouches[0];
              var realTarget = document.elementFromPoint(
                myLocation.clientX,
                myLocation.clientY,
              );

              var targetClass = $(realTarget).attr('class');
              var dragObjId = activeElement.target.id;

              var targetParentClass = $(realTarget).parent().attr('class');

              if (targetClass === 'boxAnswersColumnPodium') {
                event.preventDefault();
                const draggedObject = $(realTarget)
                  .parents('#boxQuestions')
                  .find(`#${dragObjId}`)[0];

                $(draggedObject).addClass('in-box');
                realTarget.appendChild(draggedObject);
                if (realTarget) {
                  setCurrentAnswerValue(realTarget);
                }
              } else if (
                (targetClass == 'spnBoxQuestions' ||
                  targetClass == 'spnBoxQuestions in-box' ||
                  targetClass == 'spnMobileBoxQuestions' ||
                  targetClass == 'spnMobileBoxQuestions in-box') &&
                targetParentClass == 'boxAnswersColumnPodium'
              ) {
                event.preventDefault();
                const draggedObject = $(realTarget)
                  .parents('#boxQuestions')
                  .find(`#${dragObjId}`)[0];

                $(draggedObject).addClass('in-box');
                realTarget.parentNode.appendChild(draggedObject);
                if (realTarget.parentNode) {
                  setCurrentAnswerValue(realTarget.parentNode);
                }
              }

              activeElement.target.style.opacity = 1;
              activeElement.target.style.position = 'static';
              activeElement.target = null;
            }
          },

          dragover: function (event) {
            event.preventDefault();
          },
        },
        '.boxQuestionsPodium',
      );
    }
  }

  $.extend();

  $.fn[pluginName] = function (options) {
    return this.each(function () {
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
      }
    });
  };
})($, document, window);
